module.exports = {"orderId":true,"supplierOrderCode":true,"store":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/filters/sortEdf.json
// module id = QpR2
// module chunks = 1